import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    appBar: {
      top: "auto",
      bottom: 0,
      height:'20vh',
    },
    toolbar:{
      display:'flex',
      justifyContent:'center',
    },
    grow: {
      flexGrow: 1
    },
    card: {
      display: "flex",
      justifyContent:'space-around',
      width:300,
      height:100,
      color:'white', 
      margin:10
    },
    cover: {
      width: 151
    }
  }));

  export default useStyles;